import { Chip, chipClasses, ChipProps, styled } from '@mui/material';

type ColorOptions = 'success' | 'error' | 'warning' | 'info';

interface PillProps extends ChipProps {
  color?: ColorOptions;
}

export const Pill = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'color',
})<PillProps>(({ color = 'success', theme }) => {
  return {
    fontWeight: 700,
    borderRadius: 99,
    height: '20px',
    background: theme.palette[color].light,
    color: theme.palette[color].dark,
    [`& .${chipClasses.icon}`]: {
      color: theme.palette[color].dark,
    },
  };
});
